'use client';

import { sendSentryError } from '@lib/sentry';
import NextError from 'next/error';
import { useEffect } from 'react';

// NextIntlClientProvider context 외부에 있어 next-intl의 Link를 사용할 수 없음
// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    sendSentryError({ error, source: 'global-error' });
  }, [error]);

  return (
    <html>
      <body>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <h1>Something went wrong!</h1>
          <p>{error.message}</p>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '16px',
            }}
          >
            <button
              onClick={reset}
              style={{ fontSize: '16px', fontWeight: 'bold' }}
            >
              Try again
            </button>
            <Link href="/" style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Go to Home
            </Link>
          </div>
        </div>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
